module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[path][name].[ext]&context=./!./favicon.ico
// module id = 217
// module chunks = 0